export default "__VITE_ASSET__DNYhTyhY__"